import { combineReducers } from '@reduxjs/toolkit'
import notificationReducer from './notification'
import recipientsReducer from './recipients'

const combinedReducer = combineReducers({
  notification: notificationReducer,
  recipients: recipientsReducer,
})

export default combinedReducer
